<template>
  <div class="flex justify-center w-full font-zona">
    <div class="w-full min-[1200px]:w-4/5 max-[1200px]:mx-3 py-10">
      <div class="mt-4">
        <h1 class="font-bold uppercase text-lg sm:text-2xl text-center">
          {{
            lang === "mn"
              ? "Хариуцлагатай уул уурхайн олон талт зөвлөл"
              : "Responsible Mining Multi-Stakeholder Council"
          }}
        </h1>
        <div class="flex max-md:flex-col md:items-start gap-10 w-full">
          <div
            v-if="multiAdvisors.length > 0"
            class="flex max-md:flex-col md:items-start gap-10 w-full my-20"
          >
            <div class="sm:w-1/3">
              <h1 class="font-bold uppercase text-2xl mb-2">
                {{ lang === "mn" ? "Зөвлөх" : "Advisor" }}
              </h1>
            </div>

            <div
              class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 sm:w-2/3 gap-5"
            >
              <div
                v-for="multiAdvisor in multiAdvisors"
                :key="multiAdvisor.id"
                v-motion-fade-visible-once
                class="group"
              >
                <div class="relative flex justify-center">
                  <img
                    v-if="multiAdvisor.profile"
                    :src="multiAdvisor.profile"
                    alt="multiAdvisor"
                    class="rounded-full w-36 h-36 object-contain"
                  />
                  <div v-else class="w-36 h-36 border rounded-full"></div>
                </div>
                <h6 class="font-bold text-center text-lg">
                  {{ lang === "mn" ? multiAdvisor.name : multiAdvisor.name_en }}
                </h6>
                <h6 class="font-bold text-center my-1">
                  {{
                    lang === "mn"
                      ? multiAdvisor.position
                      : multiAdvisor.position_en
                  }}
                </h6>
                <p class="text-center font-light text-sm">
                  {{ multiAdvisor.email }}
                </p>
                <div
                  v-if="multiAdvisor.bio || multiAdvisor.bio_en"
                  class="absolute inset-0 rounded-lg bg-black/70 flex items-center justify-center text-white text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-1"
                >
                  <p
                    class="text-sm font-medium leading-snug max-h-48 overflow-y-auto scrollbar-thin scrollbar-thumb-white/30"
                  >
                    {{ lang === "mn" ? multiAdvisor.bio : multiAdvisor.bio_en }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();
const lang = computed(() => store.getters.getLanguage);

const multiAdvisors = ref([]);
const isLoading = ref(false);

const aboutUs = computed(() => store.getters["client/getAboutUs"]);

const fetchAboutUs = async () => {
  try {
    isLoading.value = true;
    await store.dispatch("client/fetchAboutUs");

    if (aboutUs.value) {
      multiAdvisors.value = aboutUs.value.filter(
        (item) => item.about_category === "MultilateralAdvisor",
      );
    }

    console.log("Multilateral Advisors:", multiAdvisors.value);
  } catch (err) {
    return err;
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchAboutUs();
});
</script>
